module.exports = __webpack_public_path__ + "img/drug_card_layout__same__en.5d432356.png";